import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'

import { ProductPagesTypes, productsPagesDataMap } from '../../data/products-pages'
import { RegionalPagesPath, regionalPagesProps } from '../../regions/runtime-components/pages-props'
import { Product } from '../../screens/product'
import { serverSideResolveCity } from '../../ssr-resolvers/next-ssr-resolvers'

const ProductRealEstatePage: NextPageFC<Empty, PageLayoutOwnProps> = () =>
	Product(productsPagesDataMap[ProductPagesTypes.realEstate])

ProductRealEstatePage.layout = regionalPagesProps[RegionalPagesPath.podZalogNedv].layout
ProductRealEstatePage.headProps = regionalPagesProps[RegionalPagesPath.podZalogNedv].headProps

export const getServerSideProps = serverSideResolveCity

export default ProductRealEstatePage
